module.exports = __webpack_public_path__ + "img/live_q.a7057664.png";